let sb = require('@sb/util')

export default {
	props: ['ev'],

	render () {
		return null
		let submits = []
		let attachments = sb.get(this.ev, 'data.message.attachments') || []
		sb.each(attachments, att => {
			if (!att) return
			if (att.type !== 'form_submit') return
			if (!att.form_submit) return
			submits.push(att.form_submit)
		})

		let $submits = sb.map(submits, (submit, index) => (
			<div class="info-message">
				<span>{this.$t('prechat_form_thanks')}</span>
			</div>
		))

		return <div>{$submits}</div>
	},
}
